import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-is-active',
  imports: [NgClass],
  standalone: true,
  templateUrl: './is-active.component.html',
  styleUrl: './is-active.component.scss'
})
export class IsActiveComponent {
  @Input() isActive = false;
  @Input() dot = false;
}
